import { IColumn } from "@fluentui/react";
import { EControlType } from "components/ControlWrapper";
import Formatters from "global/Utility/Formatters";
import { formatDate, parseDate } from "global/Utility/TSFunctions";
import {
    IBooleanValue as FAM_IBooleanValue,
    IDateValue as FAM_IDateValue,
    IEntityReferenceValue as FAM_IEntityReferenceValue,
    IOptionSetValue as FAM_IOptionSetValue,
    IRef as FAM_IRef,
    IStringValue as FAM_IStringValue,
    TValue as FAM_TValue
} from "model/FlexibleAttributeModel";
import EntityLink from "../EntityLink";
import RefLink from "../RefLink";
import { IExtendedColumn } from "model/IExtendedColumn";

// =============================================================================
// Render
// =============================================================================

export const onRenderColumnCurrency = (item?: any, index?: number, column?: IColumn) => {
    if (!column?.fieldName)
        return <div style={{ textAlign: 'center' }}>---</div>

    const value = item[column.fieldName];

    if (!value)
        return <div style={{ textAlign: 'center' }}>---</div>

    const displayValue = Formatters.ToCurrencyUSD(value);
    return <div style={{ textAlign: 'center' }}>{displayValue}</div>
}

export const onRenderColumnRef = (item?: Record<string, FAM_IRef>, index?: number, column?: IExtendedColumn) => {
    if (!column?.fieldName)
        return <div style={{ textAlign: 'left' }}>---</div>

    if (!item)
        return <div style={{ textAlign: 'left' }}>---</div>

    const value = item[column.fieldName];

    if (!value)
        return <div style={{ textAlign: 'left' }}>---</div>

    return <div style={{ textAlign: 'left' }}>
        <RefLink
            id={value.id}
            name={value.name ?? ""}
            type={column.fieldName}
            disabled={column.disableNavigation}
        />
    </div>

}

export const onRenderColumnBenefitRef = (item?: Record<string, FAM_IRef>, index?: number, column?: IExtendedColumn) => {
    if (!column?.fieldName)
        return <div style={{ textAlign: 'left' }}>---</div>

    if (!item)
        return <div style={{ textAlign: 'left' }}>---</div>

    const value = item[column.fieldName];

    if (!value)
        return <div style={{ textAlign: 'left' }}>---</div>

    return <div style={{ textAlign: 'left' }}>
        <RefLink
            id={value.id}
            name={value.name ?? ""}
            type={'benefitRef'}
            disabled={column.disableNavigation}
        />
    </div>
}


export const onRenderRowFAM = (item?: Record<string, FAM_TValue>, index?: number, column?: IColumn) => {
    if (!column?.fieldName)
        return <></>

    if (!item)
        return <></>

    let value = null as (string | null);

    const fieldValue = item[column.fieldName];

    if (fieldValue)
        if (fieldValue.type === "string") {
            value = fieldValue.value;
        } else if (fieldValue.type === "bool") {
            value = fieldValue.value ? "Yes" : "No";
        } else if (fieldValue.type === "date" && fieldValue.value) {
            value = Formatters.ToShortDate(fieldValue.value);
        } else if (fieldValue.type === "optionset") {
            value = fieldValue.name;
        } else if (fieldValue.type === "entity") {
            value = fieldValue.name;
        } else if (fieldValue.type === "number") {
            value = fieldValue.value.toString();
        }

    return <div>{value}</div>;
}


// =============================================================================
// Render
// =============================================================================
export const onRenderColumnFAM = (attributeType: EControlType) => {

    switch (attributeType) {

        case EControlType.currency:
            return onRenderColumnFAMCurrency;

        case EControlType.lookup:
            return onRenderColumnFAMLookup;

        case EControlType.optionset:
            return onRenderColumnPropertyName;

        case EControlType.boolean:
            return onRenderColumnFAMBoolean;

        case EControlType.date:
            return onRenderColumnFAMDate;

        case EControlType.text:
            return onRenderColumnFAMString;

        case EControlType.multiText:
            return onRenderColumnFAMString;

        case EControlType.wholeNumber:
            return onRenderColumnFAMWholeNumber;

        case EControlType.decimal:
            return onRenderColumnFAMWholeNumber;

        case EControlType.costshare:
            return onRenderColumnPropertyName;

        case EControlType.multiOptionset:
            return onRenderColumnFAMString;

        default:
            console.warn('Mapping has not been setup.', attributeType);
            return (item?: any, index?: number, column?: IColumn) => { return <div>Unknown Mapping</div> }
    }

}

export const onRenderColumnFAMString = (item?: Record<string, FAM_IStringValue>, index?: number, column?: IColumn) => {
    if (!column?.fieldName)
        return <div style={{ textAlign: 'left' }}>---</div>

    if (!item)
        return <div style={{ textAlign: 'left' }}>---</div>

    const value = item[column.fieldName];

    if (!value)
        return <div style={{ textAlign: 'left' }}>---</div>

    const displayValue = value.value;
    return <div style={{ textAlign: 'left' }}>{displayValue}</div>
}

export const onRenderColumnFAMLookup = (item?: Record<string, FAM_IEntityReferenceValue>, index?: number, column?: IColumn) => {
    if (!column?.fieldName)
        return <div style={{ textAlign: 'left' }}>---</div>

    if (!item)
        return <div style={{ textAlign: 'left' }}>---</div>

    const value = item[column.fieldName];

    if (!value)
        return <div style={{ textAlign: 'left' }}>---</div>

    return <div style={{ textAlign: 'left' }}><EntityLink entity={value}></EntityLink></div>

}

export const onRenderColumnFAMBoolean = (item?: Record<string, FAM_IBooleanValue>, index?: number, column?: IColumn) => {
    if (!column?.fieldName)
        return <div style={{ textAlign: 'left' }}>---</div>

    if (!item)
        return <div style={{ textAlign: 'left' }}>---</div>

    const value = item[column.fieldName];

    if (!value || value.value === undefined)
        return <div style={{ textAlign: 'left' }}>---</div>

    const displayValue = value.value === true
        ? "Yes"
        : value.value === false
            ? "No"
            : "---";

    return <div style={{ textAlign: 'left' }}>{displayValue}</div>
}

export const onRenderColumnFAMDate = (item?: Record<string, FAM_IDateValue>, index?: number, column?: IColumn) => {
    if (!column?.fieldName)
        return <div style={{ textAlign: 'left' }}>---</div>

    if (!item)
        return <div style={{ textAlign: 'left' }}>---</div>

    const value = item[column.fieldName];

    if (!value?.value)
        return <div style={{ textAlign: 'left' }}>---</div>

    const displayValue = formatDate(parseDate(value.value, 'local:yyyy-MM-dd'), 'en-US-ET')
    return <div style={{ textAlign: 'left' }}>{displayValue}</div>
}

export const onRenderColumnFAMCurrency = (item?: Record<string, FAM_IStringValue>, index?: number, column?: IColumn) => {
    if (!column?.fieldName)
        return <div style={{ textAlign: 'right' }}>---</div>

    if (!item)
        return <div style={{ textAlign: 'right' }}>---</div>

    const value = item[column.fieldName]?.value;

    if (value === null || value === undefined)
        return <div style={{ textAlign: 'right' }}>---</div>

    const displayValue = Formatters.ToCurrencyUSD(Number(value));

    return <div style={{ textAlign: 'right' }}>{displayValue}</div>
}



export const onRenderColumnFAMWholeNumber = (item?: Record<string, FAM_IStringValue>, index?: number, column?: IColumn) => {
    if (!column?.fieldName)
        return <div style={{ textAlign: 'right' }}>---</div>

    if (!item)
        return <div style={{ textAlign: 'right' }}>---</div>

    const value = item[column.fieldName]?.value;

    if (value === null || value === undefined)
        return <div style={{ textAlign: 'right' }}>---</div>

    const displayValue = value.toString();

    return <div style={{ textAlign: 'right' }}>{displayValue}</div>
}

export const onRenderColumnFAMDecimal = (item?: Record<string, FAM_IStringValue>, index?: number, column?: IColumn) => {
    if (!column?.fieldName)
        return <div style={{ textAlign: 'right' }}>---</div>

    if (!item)
        return <div style={{ textAlign: 'right' }}>---</div>

    const value = item[column.fieldName]?.value;

    if (value === null || value === undefined)
        return <div style={{ textAlign: 'right' }}>---</div>

    const displayValue = value.toString();

    return <div style={{ textAlign: 'right' }}>{displayValue}</div>
}

export const onRenderColumnPropertyName = (item?: Record<string, FAM_IOptionSetValue | FAM_IEntityReferenceValue>, index?: number, column?: IColumn) => {
    if (!column?.fieldName)
        return <div style={{ textAlign: 'left' }}>---</div>

    if (!item)
        return <div style={{ textAlign: 'left' }}>---</div>

    const value = item[column.fieldName];

    if (!value)
        return <div style={{ textAlign: 'left' }}>---</div>

    return <div style={{ textAlign: 'left' }}>{value.name}</div>
}


export const onRenderColumnPropertyString = (item?: Record<string, string>, index?: number, column?: IColumn) => {
    if (!column?.fieldName)
        return <div style={{ textAlign: 'left' }}>---</div>

    if (!item)
        return <div style={{ textAlign: 'left' }}>---</div>

    const value = item[column.fieldName];

    if (!value)
        return <div style={{ textAlign: 'left' }}>---</div>

    return <div style={{ textAlign: 'left' }}>{value}</div>
}


// =============================================================================
// Sort FAM
// =============================================================================
export type TSortPredicate = (itemA?: any, itemB?: any, index?: number, column?: IColumn) => 1 | 0 | -1;
export type TReturnSortPredicate = (attributeType: EControlType) => TSortPredicate;

export const sortPredicateColumnFAM: TReturnSortPredicate = (attributeType: EControlType) => {

    switch (attributeType) {

        case EControlType.currency:
            return sortPredicateColumnFAMCurrency;

        case EControlType.lookup:
            return sortPredicateColumnFAMLookup;

        case EControlType.optionset:
            return sortPredicateColumnFAMNameProperty;

        case EControlType.boolean:
            return sortPredicateColumnFAMBoolean;

        case EControlType.date:
            return sortPredicateColumnFAMDate;

        case EControlType.text:
            return sortPredicateColumnFAMString;

        case EControlType.multiText:
            return sortPredicateColumnFAMString;

        case EControlType.wholeNumber:
            return sortPredicateColumnFAMWholeNumber;

        case EControlType.decimal:
            return sortPredicateColumnFAMWholeNumber;

        case EControlType.costshare:
            return sortPredicateColumnFAMNameProperty;
    }
    return () => -1;

}

const Negative_Number_MIN_VALUE = (Number.MIN_VALUE * -1).toString();
export const sortPredicateColumnFAMCurrency: TSortPredicate = (itemA?: Record<string, FAM_IStringValue>, itemB?: Record<string, FAM_IStringValue>, index?: number, column?: IColumn) => {
    if (!column?.fieldName)
        return -1;

    const valueA = itemA?.[column.fieldName]?.value ?? Negative_Number_MIN_VALUE;
    const valueB = itemB?.[column.fieldName]?.value ?? Negative_Number_MIN_VALUE;

    return Number(valueA) > Number(valueB) ? 1 : -1;
}

export const sortPredicateColumnFAMLookup: TSortPredicate = (itemA?: Record<string, FAM_IEntityReferenceValue>, itemB?: Record<string, FAM_IEntityReferenceValue>, index?: number, column?: IColumn) => {
    if (!column?.fieldName)
        return -1;

    const valueA = itemA?.[column.fieldName]?.name ?? '';
    const valueB = itemB?.[column.fieldName]?.name ?? '';

    return valueA > valueB ? 1 : -1;
}

export const sortPredicateColumnFAMNameProperty: TSortPredicate = (itemA?: Record<string, FAM_IOptionSetValue | FAM_IEntityReferenceValue>, itemB?: Record<string, FAM_IOptionSetValue | FAM_IEntityReferenceValue>, index?: number, column?: IColumn) => {
    if (!column?.fieldName)
        return -1;

    const valueA = itemA?.[column.fieldName]?.name ?? '';
    const valueB = itemB?.[column.fieldName]?.name ?? '';

    return valueA > valueB ? 1 : -1;
}

export const sortPredicateColumnFAMString: TSortPredicate = (itemA?: Record<string, FAM_IStringValue>, itemB?: Record<string, FAM_IStringValue>, index?: number, column?: IColumn) => {
    if (!column?.fieldName)
        return -1;

    const valueA = itemA?.[column.fieldName]?.value ?? '';
    const valueB = itemB?.[column.fieldName]?.value ?? '';

    return valueA > valueB ? 1 : -1;
}

export const sortPredicateColumnFAMBoolean: TSortPredicate = (itemA?: Record<string, FAM_IBooleanValue>, itemB?: Record<string, FAM_IBooleanValue>, index?: number, column?: IColumn) => {
    if (!column?.fieldName)
        return -1;

    const valueA = itemA?.[column.fieldName]?.value ?? false;
    const valueB = itemB?.[column.fieldName]?.value ?? false;

    // console.log("sortPredicateColumnFAMBoolean:", itemA?.[column.fieldName]?.value, itemB?.[column.fieldName]?.value, valueA > valueB);

    return valueA > valueB ? 1 : -1;
}

export const sortPredicateColumnFAMDate: TSortPredicate = (itemA?: Record<string, FAM_IDateValue>, itemB?: Record<string, FAM_IDateValue>, index?: number, column?: IColumn) => {
    if (!column?.fieldName)
        return -1;

    const valueA = itemA?.[column.fieldName]?.value ?? '';
    const valueB = itemB?.[column.fieldName]?.value ?? '';

    return valueA > valueB ? 1 : -1;
}

export const sortPredicateColumnFAMWholeNumber: TSortPredicate = (itemA?: Record<string, FAM_IStringValue>, itemB?: Record<string, FAM_IStringValue>, index?: number, column?: IColumn) => {
    if (!column?.fieldName)
        return -1;

    const valueA = itemA?.[column.fieldName]?.value ?? '';
    const valueB = itemB?.[column.fieldName]?.value ?? '';

    return Number(valueA) > Number(valueB) ? 1 : -1;
}

export const sortPredicateColumnPropertyString: TSortPredicate = (itemA?: Record<string, string>, itemB?: Record<string, string>, index?: number, column?: IColumn) => {
    if (!column?.fieldName)
        return -1;

    const valueA = itemA?.[column.fieldName] ?? '';
    const valueB = itemB?.[column.fieldName] ?? '';

    return valueA > valueB ? 1 : -1;
}

export const sortPredicateColumnPropertyName: TSortPredicate = (itemA?: Record<string, FAM_IOptionSetValue | FAM_IEntityReferenceValue>, itemB?: Record<string, FAM_IOptionSetValue | FAM_IEntityReferenceValue>, index?: number, column?: IColumn) => {
    if (!column?.fieldName)
        return -1;

    const valueA = itemA?.[column.fieldName]?.name ?? '';
    const valueB = itemB?.[column.fieldName]?.name ?? '';

    return valueA > valueB ? 1 : -1;
}

// =============================================================================
// Filter
// =============================================================================
export type TFilterPredicate = (item: any, testValue: string | null, column: IColumn) => boolean;
export type TReturnFilterPredicate = (attributeType: EControlType) => TFilterPredicate;

// TODO make this injectable property, or class up this whole thing during refactor, for now its ok
const regexCache: Record<string, RegExp> = {};

export const filterPredicateColumnFAM: TReturnFilterPredicate = (attributeType: EControlType) => {

    switch (attributeType) {

        case EControlType.currency:
            return filterPredicateColumnFAMCurrency;

        case EControlType.lookup:
            return filterPredicateColumnFAMLookup;

        case EControlType.optionset:
            return filterPredicateColumnFAMName;

        case EControlType.boolean:
            return filterPredicateColumnFAMBoolean;

        case EControlType.date:
            return filterPredicateColumnFAMDate;

        case EControlType.text:
            return filterPredicateColumnFAMString;

        case EControlType.multiText:
            return filterPredicateColumnFAMString;

        case EControlType.wholeNumber:
            return filterPredicateColumnFAMWholeNumber;

        case EControlType.decimal:
            return filterPredicateColumnFAMWholeNumber;

        case EControlType.costshare:
            return filterPredicateColumnFAMName;

    }
    return () => true;
}

export const filterPredicateColumnFAMString: TFilterPredicate = (item: Record<string, FAM_IStringValue>, testValue: string | null, column: IColumn) => {

    if (!column?.fieldName)
        return true;

    if (!testValue)
        return true;

    const value = item?.[column.fieldName];

    let regex = regexCache[testValue];
    if (!regex)
        regexCache[testValue] = regex = new RegExp(testValue, "i");

    return regex.test(value?.value);
}

export const filterPredicateColumnFAMWholeNumber: TFilterPredicate = (item: Record<string, FAM_IStringValue>, testValue: string | null, column: IColumn) => {

    if (!column?.fieldName)
        return true;

    if (!testValue)
        return true;

    const value = item?.[column.fieldName];

    if (!value)
        return false;

    let regex = regexCache[testValue];
    if (!regex)
        regexCache[testValue] = regex = new RegExp(testValue, "i");

    const textValue = value.value.toString();

    return regex.test(textValue);
}

export const filterPredicateColumnFAMBoolean: TFilterPredicate = (item: Record<string, FAM_IBooleanValue>, testValue: string | null, column: IColumn) => {
    if (!column?.fieldName)
        return true;

    if (!testValue)
        return true;

    const value = item[column.fieldName];

    if (!value)
        return false;

    const textValue = value.value === true
        ? "Yes"
        : value.value === false
            ? "No"
            : "";

    let regex = regexCache[testValue];
    if (!regex)
        regexCache[testValue] = regex = new RegExp(testValue, "i");

    return regex.test(textValue);
}

export const filterPredicateColumnFAMCurrency: TFilterPredicate = (item: Record<string, FAM_IStringValue>, testValue: string | null, column: IColumn) => {
    if (!column?.fieldName)
        return true;

    if (!testValue)
        return true;

    const value = item[column.fieldName]?.value;

    if (!value)
        return false;

    let regex = regexCache[testValue];
    if (!regex)
        regexCache[testValue] = regex = new RegExp(testValue, "i");

    return regex.test(value);
}

export const filterPredicateColumnFAMDate: TFilterPredicate = (item: Record<string, FAM_IDateValue>, testValue: string | null, column: IColumn) => {
    if (!column?.fieldName)
        return true;

    if (!testValue)
        return true;

    const value = item[column.fieldName];

    if (!value)
        return false;

    let regex = regexCache[testValue];
    if (!regex)
        regexCache[testValue] = regex = new RegExp(testValue, "i");

    const textValue = formatDate(parseDate(value.value, 'local:yyyy-MM-dd'), 'en-US-ET');

    return regex.test(textValue);
}

export const filterPredicateColumnFAMLookup: TFilterPredicate = (item: Record<string, FAM_IEntityReferenceValue>, testValue: string | null, column: IColumn) => {
    if (!column?.fieldName)
        return true;

    if (!testValue)
        return true;

    const value = item[column.fieldName];

    let regex = regexCache[testValue];
    if (!regex)
        regexCache[testValue] = regex = new RegExp(testValue, "i");

    const textValue = value.name;

    return regex.test(textValue);
}

export const filterPredicateColumnFAMName: TFilterPredicate = (item: Record<string, FAM_IOptionSetValue | FAM_IEntityReferenceValue>, testValue: string | null, column: IColumn) => {
    if (!column?.fieldName)
        return true;

    if (!testValue)
        return true;

    const value = item[column.fieldName];

    if (!value)
        return false;

    let regex = regexCache[testValue];
    if (!regex)
        regexCache[testValue] = regex = new RegExp(testValue, "i");

    const textValue = value.name;

    return regex.test(textValue);
}

export const filterPredicateColumnPropertyString: TFilterPredicate = (item: Record<string, string>, testValue: string | null, column: IColumn) => {
    if (!column?.fieldName)
        return true;

    if (!testValue)
        return true;

    const value = item?.[column.fieldName] ?? '';

    let regex = regexCache[testValue];
    if (!regex)
        regexCache[testValue] = regex = new RegExp(testValue, "i");

    return regex.test(value);
}

export const filterPredicateColumnPropertyName: TFilterPredicate = (item: Record<string, FAM_IOptionSetValue | FAM_IEntityReferenceValue>, testValue: string | null, column: IColumn) => {
    if (!column?.fieldName)
        return true;

    if (!testValue)
        return true;

    const value = item?.[column.fieldName]?.name ?? '';

    let regex = regexCache[testValue];
    if (!regex)
        regexCache[testValue] = regex = new RegExp(testValue, "i");

    return regex.test(value);
}

